import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(3),
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(2),
    textAlign: 'center',
  },
  instructions: {
    textAlign: 'center',
    marginBottom: theme.spacing(3),
    color: '#666',
  },
  qrContainer: {
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: theme.spacing(3),
  },
  qrImage: {
    display: 'block',
    width: '200px',
    height: '200px',
  },
  alternativeText: {
    marginBottom: theme.spacing(2),
    color: '#666',
    textAlign: 'center',
  },
  secretContainer: {
    width: '100%',
    maxWidth: '400px',
    marginBottom: theme.spacing(1),
  },
  secretField: {
    backgroundColor: '#fff',
    '& .MuiOutlinedInput-root': {
      fontFamily: 'monospace',
      fontSize: '14px',
    },
  },
  copyButton: {
    '&:hover': {
      backgroundColor: 'rgba(255, 69, 0, 0.1)',
    },
  },
  copiedText: {
    marginBottom: theme.spacing(2),
  },
  stepsContainer: {
    marginTop: theme.spacing(3),
    width: '100%',
    maxWidth: '400px',
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: '8px',
  },
  stepsTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  stepsList: {
    margin: 0,
    paddingLeft: theme.spacing(2.5),
    '& li': {
      marginBottom: theme.spacing(1),
    },
  },
}))

export default useStyles
